import MkuCollapse from './transition';

MkuCollapse.install = function (Vue) {
  Vue.component(MkuCollapse.name, MkuCollapse);
};

export default MkuCollapse;
